import AllItemsConstants from 'sharedreact/constants/AllItemsConstants';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

// exported functions
function refresh (): void {
  AppDispatcher.dispatch({
    actionType: AllItemsConstants.REFRESH,
    logLevel: 'trace'
  });
}

export default {
  refresh
};
